import { Glue42Core } from "@glue42/core";

import {Glue42Office} from "../../../glue4office";
import {getAttachment} from "../methods/getAttachment";

export class AttachmentImpl implements Glue42Office.Outlook.Attachment {
    public cookie: string;
    public emailIds: Glue42Office.Outlook.T42Id[];
    public data: string;
    public ids: Glue42Office.Outlook.T42Id[];
    public name: string;
    public sizeHint: number;
    public errorMessage: string;
    public more: boolean;
    public success: boolean;
    public parent: Glue42Office.Outlook.Email | Glue42Office.Outlook.Task;
    private agm: Glue42Core.AGM.API;

    constructor(attachment: Glue42Office.Outlook.T42Attachment, agm: Glue42Core.AGM.API, parent?: Glue42Office.Outlook.Email | Glue42Office.Outlook.Task) {
        this.cookie = attachment.cookie;
        this.emailIds = attachment.emailIds;
        this.data = attachment.data;
        this.ids = attachment.ids;
        this.name = attachment.name;
        this.sizeHint = attachment.sizeHint;
        this.errorMessage = attachment.errorMessage;
        this.more = attachment.more;
        this.success = attachment.success;
        this.agm = agm;

        if (parent) {
            this.parent = parent;
        }
    }

    public getData(callback?: (percent: number) => number): Promise<string> {
        return getAttachment(this.agm, this.emailIds, this.ids, callback);
    }
}
